module.exports = __webpack_public_path__ + "img/NR.8c7bcea7.svg";